<template>
  <v-row dense align="center">
    <DatetimePicker
      :type="type"
      :single-line="singleLine"
      :dense="dense"
      :hide-details="hideDetails"
      :hide-icon="hideIcon"
      v-model="model"
      v-if="!$vuetify.theme.dark"
      :label="label"
      :error-messages="errorMessages"
      :disabled="disabled"
      :disabled-before-now="disabledBeforeNow"
      :disabled-before-today="disabledBeforeToday"
      :disabled-after-now="disabledAfterNow"
      :disabled-after-today="disabledAfterToday"
      :removeIcon="removeIcon"
      :readonly="readonly"
      :disabledBeforeSpecifyTime="disabledBeforeSpecifyTime"
      :minuteStep="minuteStep"
    />
    <DatetimePickerDark
      :type="type"
      :single-line="singleLine"
      :dense="dense"
      :hide-details="hideDetails"
      :hide-icon="hideIcon"
      v-model="model"
      v-if="$vuetify.theme.dark"
      :label="label"
      :error-messages="errorMessages"
      :disabled="disabled"
      :disabled-before-now="disabledBeforeNow"
      :disabled-before-today="disabledBeforeToday"
      :disabled-after-now="disabledAfterNow"
      :disabled-after-today="disabledAfterToday"
      :removeIcon="removeIcon"
      :readonly="readonly"
      :disabledBeforeSpecifyTime="disabledBeforeSpecifyTime"
      :minuteStep="minuteStep"
    />
  </v-row>
</template>

<script>
import i18n from "@/i18n";
import DatetimePicker from "@/plugins/datepicker/DatetimePicker";
import DatetimePickerDark from "@/plugins/datepicker/DatetimePickerDark";

export default {
  name: "SearcherDatetime",

  props: {
    value: String,
    label: String,
    type: String,
    singleLine: Boolean,
    dense: Boolean,
    hideDetails: Boolean,
    hideIcon: Boolean,
    required: Boolean,
    disabled: Boolean,
    disabledBeforeNow: Boolean,
    disabledBeforeToday: Boolean,
    disabledAfterNow: Boolean,
    disabledAfterToday: Boolean,
    removeIcon: Boolean,
    errors: Array,
    readonly: Boolean,
    disabledBeforeSpecifyTime: String,
    minuteStep: Number,
  },

  components: {
    DatetimePicker,
    DatetimePickerDark,
  },

  data: () => ({
    model: "",
    errorMessages: null,
  }),

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.model = this.value ? this.value.replaceAll("/", "-") : this.value;
      },
    },
    model: {
      //immediate: true, //初始赋值也调用
      handler() {
        this.errorMessages =
          this.required && !this.model
            ? this.errors
              ? this.errors
              : [i18n.t("$validate.messages.trequired")]
            : null;
        this.$emit("input", this.model);
      },
    },
    errors: {
      handler() {
        this.errorMessages =
          this.required && !this.model
            ? this.errors
              ? this.errors
              : [i18n.t("$validate.messages.trequired")]
            : null;
      },
    },
  },
};
</script>
